export default __webpack_public_path__ + "static/media/LO16.8ece3ee5.mp3";